import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import api from '@/api';
import UserEdit from '../edit/index';
export default {
  name: 'UserList',
  components: {
    UserEdit: UserEdit
  },
  data: function data() {
    return {
      isSelect: this.checkauthority('user_select'),
      isCreate: this.checkauthority('user_add'),
      isUpdate: this.checkauthority('user_edit'),
      isDelete: this.checkauthority('user_del'),
      selectForm: {
        userName: '',
        name: ''
      },
      editDisabled: false,
      dialogVisible: false,
      pageNo: 1,
      pageSize: 10,
      tableSelects: [],
      tableData: [],
      pageTotal: 0,
      centerDialogVisible: false,
      userStatsEunm: [],
      userStatsEunmType: []
    };
  },
  methods: {
    /**
     * 获取枚举的方法 created
     */
    initEunmData: function initEunmData() {
      this.getEnumList('', this.userStatsEunm);
      this.getEnumList('', this.userStatsEunmType);
    },
    getEnumList: function getEnumList(key, items) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var par, res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              par = {
                keys: key
              };
              _context.n = 1;
              return api.GET_ENUMERATION_LIST(par);
            case 1:
              res = _context.v;
              items = res.body;
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    switchChange: function switchChange(value) {
      this.updateStats(value);
    },
    checkStatsType: function checkStatsType(data) {
      if (data.stats === 0) {
        return 'success';
      } else {
        return 'danger';
      }
    },
    checkStats: function checkStats(data) {
      if (data.stats === 0) {
        return '正常';
      } else {
        return '已注销';
      }
    },
    btnCheckStats: function btnCheckStats(data) {
      if (data.stats === 0) {
        return '注销';
      } else {
        return '恢复';
      }
    },
    updateStats: function updateStats(data) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var par;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              par = {
                id: data.id,
                stats: data.stats
              };
              _context2.n = 1;
              return api.UPDATE_USER(par);
            case 1:
              _this.initTableData();
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    dalete: function dalete(index, data) {
      var _this2 = this;
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this2.daleteApi(index, data);
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    daleteApi: function daleteApi(index, data) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var par;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              par = {
                id: data.id
              };
              _context3.n = 1;
              return api.DELETE_USER(par);
            case 1:
              _this3.initTableData();
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteBatchApi: function deleteBatchApi(par) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return api.DELETE_BATCH_USER(par);
            case 1:
              _this4.$message.success('操作成功');
              _this4.initTableData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    deleteBatch: function deleteBatch() {
      var _this5 = this;
      if (this.tableSelects.length === 0) {
        this.$message.error('请勾选要删除的表格数据');
        return;
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var par = [];
        _this5.tableSelects.forEach(function (element) {
          par.push(element.id);
        });
        _this5.deleteBatchApi(par);
      }).catch(function () {
        _this5.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    info: function info(index, data) {
      this.editDisabled = true;
      this.dialogVisible = true;
      this.$refs.edit.setData(data);
    },
    edit: function edit(index, data) {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.setData(data);
    },
    toAdd: function toAdd() {
      this.dialogVisible = true;
      this.editDisabled = false;
      this.$refs.edit.initData();
    },
    userEditClose: function userEditClose() {
      this.dialogVisible = false;
    },
    reset: function reset() {
      this.selectForm.userName = '';
      this.selectForm.name = '';
      this.initTableData();
    },
    search: function search() {
      this.pageNo = 1;
      this.initTableData();
    },
    initTableData: function initTableData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var par, res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              par = {
                pageNo: _this6.pageNo,
                pageSize: _this6.pageSize,
                userName: _this6.selectForm.userName,
                name: _this6.selectForm.name
              };
              _context5.n = 1;
              return api.GET_SYS_USER_LIST(par);
            case 1:
              res = _context5.v;
              _this6.tableData = res.body.datas;
              _this6.pageTotal = res.body.sumDataCount;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.initTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.initTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.tableSelects = val;
    }
  },
  created: function created() {
    if (this.isSelect) {
      return;
    }
    this.initTableData();
  }
};